import template from './project-payments-report.html';
import controller from './project-payments-report.controller';
import './project-payments-report.scss';

const projectPaymentsReportComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$filter', '$uibModal', 'projectService', 'settingsService', 'userService', 'utils'];

export default projectPaymentsReportComponent;
